import React, {useMemo, useState} from 'react'
import {Avatar, Grid, makeStyles, MenuItem} from '@material-ui/core'
import {useDispatch, useSelector} from 'react-redux'
import AntDataGrid from '../../shared/components/AntDataGrid'
import ItemModel from '../items/model/item'
import FirstItem from './updateForms/FirstItem'
import SecondItem from './updateForms/SecondItem'
import {fetchInternalIdManyFound, fetchInternalIdNotFound, selectSyncErrors} from "../../redux/slices/syncErrors";
import {nanoid} from "@reduxjs/toolkit";
import {Box, TextField} from "@mui/material";


export const CORRECTION_TYPES = {
    MANY_INRERNAL_ID: "InternalIdManyFound",
    NOT_FOUND_INTERNAL_ID: "InternalIdNotFound"
}


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
}))

let isInitialized = false;

const CorrectItem = () => {

    const classes = useStyles()

    const [selection, setSelection] = React.useState(1)

    const [selectItem1, setSelectItem1] = React.useState(new ItemModel())
    const [selectItem2, setSelectItem2] = React.useState(new ItemModel())

    const actionDispatch = useDispatch()

    const [filter, setFilter] = useState(CORRECTION_TYPES.MANY_INRERNAL_ID)
    const [isLoading, setIsLoading] = useState(false);

    const {list} = useSelector(selectSyncErrors);

    const items = useMemo(() => {
        return list ? list.map(item => {
            let reworked = {key: nanoid(), ...item};

            if (!('HasChilds' in reworked))
                reworked['HasChilds'] = false;

            if (!('IsProductValidated' in reworked))
                reworked['IsProductValidated'] = false;

            return item.NameP ? ({Name: item.NameP, ...reworked}) : reworked;
        }) : [];
    }, [list])

    const [barcode, setBarcode] = useState('');

    const filtered = useMemo(() => {
        return items.filter(one => one?.Barcode?.includes(barcode))
    }, [barcode, items])

    console.log(filtered)

    const colors = useMemo(() => {
        if (items) {
            let colored = {};
            let lastKey = null;
            let lastInternalId = null;

            items.forEach(({key, InternalId}) => {
                if (lastKey === null) {
                    colored[key] = 'white';
                }

                if (lastInternalId === InternalId) {
                    colored[key] = colored[lastKey];
                } else if (lastInternalId !== InternalId) {
                    if (colored[lastKey] === '#F5F5F5')
                        colored[key] = 'white';

                    if (colored[lastKey] === 'white')
                        colored[key] = '#F5F5F5';
                }

                lastKey = key;
                lastInternalId = InternalId;
            })

            return colored;
        } else return {}
    }, [items])


    if (!isInitialized) {
        setIsLoading(true);
        isInitialized = true;
        actionDispatch(fetchInternalIdManyFound({onResolve: () => setIsLoading(false)}));
    }

    const wipeSelectionItem = () => {
        setSelectItem1(new ItemModel())
        setSelectItem2(new ItemModel())
    }

    const handleSelection = (num) => {
        setSelection(num)
    }

    const handleItemSelection = (item) => {
        if (selection === 1) setSelectItem1(item)
        if (selection === 2) setSelectItem2(item)
    }

    const handleFilterChange = (filter) => {

        if (filter === CORRECTION_TYPES.MANY_INRERNAL_ID) {
            setIsLoading(true);
            actionDispatch(fetchInternalIdManyFound({onResolve: () => setIsLoading(false)}));
        }

        if (filter === CORRECTION_TYPES.NOT_FOUND_INTERNAL_ID) {
            setIsLoading(true);
            actionDispatch(fetchInternalIdNotFound({onResolve: () => setIsLoading(false)}));
        }

        setFilter(filter);
    }

    const columns = [
        {
            title: 'Image', dataIndex: "ImageUrl", key: 'ImageUrl',
            render: (ImageUrl, record, index) => ({
                props: {
                    style: {background: colors[record.key] ?? 'white'}
                },
                children: (
                    (ImageUrl !== null && ImageUrl !== "")
                        ? <Avatar src={ImageUrl} alt='image' className={classes.large}/>
                        : <Avatar> no </Avatar>
                )
            })
        },
        {
            title: 'Nom Produit', dataIndex: "Name", key: 'Name',
            render: (value, record, index) => ({
                props: {
                    style: {background: colors[record.key] ?? 'white'}
                },
                children: value
            })
        },
        {
            title: 'Code barre', dataIndex: "Barcode", key: 'Barcode',
            render: (value, record, index) => ({
                props: {
                    style: {background: colors[record.key] ?? 'white'}
                },
                children: value
            })
        },
        {
            title: 'Prosoft Id', dataIndex: "InternalId", key: 'InternalId',
            render: (value, record, index) => ({
                props: {
                    style: {background: colors[record.key] ?? 'white'}
                },
                children: value
            })
        },
    ]


    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>

                    <Box>
                        <Grid container style={{marginTop: 5, marginBottom: 5}} spacing={2}>
                            <Grid item>
                                <TextField
                                    select
                                    label="Filtre"
                                    value={filter}
                                    variant={"outlined"}
                                    onChange={event => handleFilterChange(event.target.value)}
                                >
                                    <MenuItem value={CORRECTION_TYPES.MANY_INRERNAL_ID}>Plusieurs Internal Id</MenuItem>
                                    <MenuItem value={CORRECTION_TYPES.NOT_FOUND_INTERNAL_ID}>Aucun Internal
                                        Id</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item>
                                <TextField
                                    variant={"outlined"}
                                    label={'Recherche  par code barre'}
                                    onChange={({target: {value}}) => setBarcode(value)}
                                />
                            </Grid>

                        </Grid>
                    </Box>


                    <AntDataGrid
                        isLoading={isLoading}
                        columns={columns}
                        data={filtered}
                        doubleClickAction={handleItemSelection}
                    />
                </Grid>

                <Grid container item xs={12} sm={4} spacing={1}>
                    <Grid item>
                        <FirstItem
                            selection={selection}
                            handleSelection={handleSelection}
                            Item={selectItem1}
                            wipeSelectionItem={wipeSelectionItem}
                        />
                    </Grid>
                    <Grid item>
                        <SecondItem
                            selection={selection}
                            handleSelection={handleSelection}
                            Item={selectItem2}
                            wipeSelectionItem={wipeSelectionItem}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CorrectItem
